import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        token: '=',
        companyTerms: '='
    },
    template: `
    <div class="col00">
        <div class="colholder center-col equalize">
            <div class="col col01">
                <form role="form" ng-submit="vm.save()" class="well color01">
                    <alert-error ng-if="vm.errors.activationToken">{{ vm.errors.activationToken }}</alert-error>
                    <activate errors="vm.errors" form="vm.form" company-terms="vm.companyTerms"></activate>
                    <ul class="actions01 mobile-stretch">
                        <li class="f-right"><input type="submit" value="{{ 'auth.Continue' | translate }}" class="btn main"></li>
                    </ul>
                </form>
            </div>
        </div>
    </div>
    `
})
export default class {
    constructor ($rootScope, $translate, $state, $stateParams, lodash, toastr, UserResource) {
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.toastr = toastr;
        this.lodash = lodash;
        this.UserResource = UserResource;
        this.form = {};
        this.errors = {};
    }
    save () {
        this.UserResource
            .activateAccountPublic({ _lang: this.$rootScope.company.defaultLanguage.toLowerCase() },
                this.lodash.assign({}, this.form, { activationToken: this.token })
            ).$promise
            .then(() => {
                this.toastr.success(this.$translate.instant('auth.Account is activated, please log in with new credentials.'));
                this.$state.go('unauthorized.login', { company: this.$stateParams.company });
            })
            .catch((response) => {
                this.errors = response.data.reduce((original, error) => {
                    original[error.field] = error.message;
                    return original;
                }, {});
                this.errors.hasErrors = true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/auth/activate/index.js